import PriceCode from './PriceCode';

export default PriceCode;
